import EDC from '../../../shared/globals';
import Airplane from '../animations/airplane';
import Birds from '../animations/birds';
import Clouds from '../animations/clouds';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

/**
 *
 */
EDC.Games.ShapeNames.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.ShapeNames, 5]);

  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.difficulty = 1;
  this.iteration = 0;
  this.airplane = null;
  this.birdAnim = null;
  this.clouds = null;
  this.shapes = [];
};
/**
 *
 */
EDC.Games.ShapeNames.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.ShapeNames.Scenes.Main.prototype.constructor = EDC.Games.ShapeNames.Scenes.Main;
/**
 *
 */
EDC.Games.ShapeNames.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

EDC.Games.ShapeNames.Scenes.Main.prototype.createTemplateUI = function () {
  this.createAnimations();

  this.clouds = new Clouds(this);
  this.clouds.start();

  const birdAnim = new Birds(this);
  birdAnim.start();

  this.add.sprite(this.game.config.width / 2, 1030, 'title');

  this.airplane = new Airplane(this, this.gameConfig);
  this.airplane.create();
};

EDC.Games.ShapeNames.Scenes.Main.prototype.createAnimations = function () {
  const animsCfg = {
    birdFly: {
      key: 'birdFly',
      frames: this.anims.generateFrameNumbers('bird', { start: 0, end: 7, first: 0 }),
      frameRate: 12,
      repeat: -1,
    },
    propeller: {
      key: 'propeller',
      frames: this.anims.generateFrameNumbers('airplane', { start: 0, end: 3, first: 0 }),
      frameRate: 50,
      repeat: -1,
    },
  };

  Object.entries(animsCfg).forEach(([key]) => {
    const cfg = animsCfg[key];
    this.anims.create(cfg);
  });
};
/**
 *
 */
EDC.Games.ShapeNames.Scenes.Main.prototype.nextIteration = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.shapes.forEach((elem) => {
      elem.removeInteractive();
    });
    this.showSummary();
  } else {
    for (let i = 0; i < this.shapes.length; i++) {
      this.shapes[i].destroy();
    }
    this.shapes = [];

    this.loadIteration();
  }
};
/**
 *
 */
EDC.Games.ShapeNames.Scenes.Main.prototype.loadIteration = function () {
  const summaryWidth = 1600;
  const startX = (this.game.config.width - summaryWidth) / 2;
  const startY = 700;
  const shiftY = 100;

  const iteration = this.gameConfig.sets[this.difficulty].iterations[this.iteration];

  const shapePlaceWidth = summaryWidth / iteration.choices.length;

  for (let i = 0; i < iteration.choices.length; i++) {
    const shape = this.add.container(0, startY + shiftY * (i % 2));
    const sprite = this.add.sprite(0, 0, iteration.choices[i]);
    shape.x = startX + shapePlaceWidth * i + shapePlaceWidth / 2;
    shape.add(sprite);
    shape.setSize(sprite.displayWidth, sprite.displayHeight);

    shape.setData('id', iteration.choices[i]);
    shape.setData('answerId', iteration.answer);
    const markAnim = new AnswerMark(this, shape).setScale(0.3);
    shape.setData('markAnim', markAnim);

    shape.setInteractive();
    shape.on('pointerup', this.checkAnswer.bind(this, shape));

    this.cursorManager.setDefaultDraggableEvents(shape);

    this.shapes.push(shape);
  }
  const answer = this.gameConfig.sets[this.difficulty].iterations[this.iteration].answer;
  this.airplane.setFigure(this.gameConfig.availableShapes[answer]);
  this.airplane.arrive();
};

EDC.Games.ShapeNames.Scenes.Main.prototype.checkAnswer = function (shape) {
  shape.removeInteractive();
  this.cursorManager.resetCursor();
  if (shape.alpha === 0) return;
  if (this.airplane.isCorrectAnimationRunning) return;

  if (shape.getData('id') === shape.getData('answerId')) {
    this.playCorrect();
    this.airplane.addFigureSprite(shape);
  } else {
    shape.getData('markAnim').showMark(false, () => {});
    this.tweens.add({
      targets: shape,
      scaleX: 1.8,
      scaleY: 1.8,
      duration: 800,
      delay: 1500,
      ease: 'Back.easeIn',
    });
    this.tweens.add({
      targets: shape,
      alpha: 0,
      duration: 800,
      delay: 1500,
      ease: 'Linear',
    });
    this.playWrong();
  }
};

export default EDC.Games.ShapeNames.Scenes.Main;
